import React from 'react'
import { Box, Typography } from '@mui/material'
import ConstructionIcon from '@mui/icons-material/Construction'

const WikiPage = () => {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 2,
        p: 4,
      }}
    >
      <ConstructionIcon sx={{ fontSize: 64, color: 'text.secondary' }} />
      <Typography variant="h4" color="text.primary">
        Wiki — Coming Soon
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 480 }}>
        This section is currently under construction. Documentation and guides
        will be available here soon.
      </Typography>
    </Box>
  )
}

export default WikiPage
